import { render, staticRenderFns } from "./dialogDetailPartner.vue?vue&type=template&id=50f670b7&scoped=true"
import script from "./dialogDetailPartner.vue?vue&type=script&lang=js"
export * from "./dialogDetailPartner.vue?vue&type=script&lang=js"
import style0 from "./dialogDetailPartner.vue?vue&type=style&index=0&id=50f670b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f670b7",
  null
  
)

export default component.exports